import { useEncounterStore } from '@/stores/encounter';

export function isAssessmentInProgress(): boolean {
  return Boolean(useEncounterStore().uuid);
}

export function canApplyUpdate(): boolean {
  return !isAssessmentInProgress();
}

export function canRefreshCache(): boolean {
  return !isAssessmentInProgress();
}
